import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import NavBar from "../../../../Navbar/Navbar";
import fetchModel from "../../../../../AdminAPI/ModelADM";
import fetchClient from "../../../../../AdminAPI/ClientList";
import { getDocByStatusADM } from "../../../../../AdminAPI/DocByStatusADM";
import "./AdmDocStatus.css";
import DocsTableComponent from "../../../../Dashboard/Default/TabDocs/DocsTableComponent";
import AdminFullDocTableConfig from "../../AdminFullTableDocConfig.json";
import { useTranslation } from "react-i18next";

const AdmDocStatus = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [model, setModel] = useState([]);
  const [modelName, setModelName] = useState("");
  const [client, setClient] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [documents, setDocuments] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const idToken = Cookies.get("Token");
  const selectedModel = model.find((mod) => mod.id === selectedModelId);
  const { t } = useTranslation();
  const [filter, setFilter] = useState({});
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    const storedModelId = localStorage.getItem("selectedModelId");
    const storedStatus = localStorage.getItem("selectedStatus");
    const storedClient = localStorage.getItem("selectedClient");

    if (storedModelId) setSelectedModelId(storedModelId);
    if (storedStatus) setSelectedStatus(storedStatus);
    if (storedClient) setSelectedClient(storedClient);
  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      setIsLoading(true);
      try {
        const ModelData = await fetchModel(null, idToken);
       

        const AllModels = ModelData.map((model) => ({
          id: model.ModelId,
          name: model.ModelName,
          component: model.ModelComponent,
          statusList: model.ModelDocumentStatus || [],
        }));
        
        setModel(AllModels);
      } catch (error) {
        console.error("Erreur lors du chargement des modèles", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, []);

  useEffect(() => {
    const fetchClientsForModel = async () => {
      if (!selectedModelId) return;

      try {
        const ClientData = await fetchClient(idToken, selectedModelId);
       
        setClient(ClientData);
      } catch (error) {
        console.error("Erreur lors du chargement des clients :", error);
      }
    };

    fetchClientsForModel();
  }, [selectedModelId]);

  const handleModelChange = (e) => {
    setSelectedModelId(e.target.value);
    localStorage.setItem("selectedModelId", e.target.value);
  };
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    localStorage.setItem("selectedStatus", e.target.value);
  };
  const handleClientChange = (e) => {
    setSelectedClient(e.target.value);
    localStorage.setItem("selectedClient", e.target.value);
  };

  useEffect(() => {
    if (selectedModelId && selectedStatus) {
      setDocuments([]);
      getDocByStatusFunction();
    }
  }, [selectedModelId, selectedStatus, selectedClient]);

  useEffect(() => {
    if (selectedModel?.component) {
      const name = selectedModel.component;
      const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
      setModelName(formattedName);
    } else {
      setModelName("DefaultDocs");
    }
  }, [selectedModel]);

  const getDocByStatusFunction = async () => {
    try {
      const responsdata = await getDocByStatusADM(
        selectedStatus,
        selectedModelId,
        selectedClient || null,
        idToken
      );
      setDocuments(responsdata);
      if (responsdata.length === 0) {
        setErrorMessage(t("No documents found for these filters."));
      } else {
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
      setErrorMessage(
        "Une erreur est survenue lors du chargement des documents."
      );
      setDocuments([]);
    }
  };


  return (
    <div style={{ backgroundColor: "#F7F9F9", minHeight: "100vh" }}>
      <NavBar />

      {/* --- HEADER --- */}
      <div id="adm-doc-status-header-container">
        {/* Bloc gauche : titre + trait */}
        <div id="adm-doc-status-title-block">
          <h1
            id="adm-doc-status-title"
            style={{
              fontSize: "28px",
              fontWeight: "600",
              fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: 0,
            }}
          >
            <i className="fas fa-search" style={{ color: "black" }}></i>
            {t("Doc status")}
          </h1>
          <div
            id="adm-doc-status-title-line"
            style={{
              height: "4px",
              width: "150px",
              borderRadius: "2px",
              background: "linear-gradient(90deg, steelblue, lightsteelblue)",
            }}
          />
        </div>

        {/* Bloc droit : filtres + bouton */}
        <div id="adm-doc-status-container">
        {isLoading ? (
            <p id="adm-doc-status-loading">{t("Loading models...")}</p>
        ) : (
            <select
              value={selectedModelId}
              onChange={handleModelChange}
              className="adm-doc-status-select"
              id="adm-doc-status-model-select"
            >
              <option value="">{t("Choose a model")}</option>
              {model.map((mod) => (
                <option key={mod.id} value={mod.id}>
                  {mod.id} - {mod.name}
                </option>
              ))}
            </select>
        )}

        {selectedModel && selectedModel.statusList.length > 0 && (
            <select
              value={selectedStatus}
              onChange={handleStatusChange}
              className="adm-doc-status-select"
              id="adm-doc-status-status-select"
            >
              <option value="">{t("Choose a status")}</option>
              {selectedModel.statusList.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
        )}

        {selectedModel &&
          selectedModel.statusList.length > 0 &&
          selectedStatus && (
              <select
                value={selectedClient}
                onChange={handleClientChange}
                className="adm-doc-status-select"
                id="adm-doc-status-client-select"
              >
                <option value="">{t("Choose a client")}</option>
                {client.map((client) => (
                  <option value={client.ClientId} key={client.ClientId}>
                    {client.ClientId}
                  </option>
                ))}
              </select>
            )}

          {/* Bouton reset */}
          <button
            id="adm-doc-status-reset-btn"
            className="btn btn-danger"
            onClick={() => {
              setSelectedModelId("");
              setSelectedStatus("");
              setSelectedClient("");
              setDocuments([]);
            }}
          >
            {t("Reset")}
          </button>
            </div>
      </div>

      {/* --- TABLEAU --- */}
      {selectedModelId && selectedStatus && documents.length > 0 && (
        <div id="adm-doc-status-table-container">
        <DocsTableComponent
          data={documents}
            modelName={modelName}
          modelId={selectedModelId}
          clientId={selectedClient}
          instanceId={Cookies.get("instanceId")}
          page={"DocStatus"}
          tableConfig={AdminFullDocTableConfig}
          selectedDocuments={selectedDocuments}
          setSelectedDocuments={setSelectedDocuments}
          filter={filter}
          setFilter={setFilter}
            setReturn={false}
        />
        </div>
      )}

      {/* Message d’erreur si pas de documents */}
      {selectedModelId &&
        selectedStatus &&
        documents.length === 0 &&
        errorMessage && (
          <div
            id="adm-doc-error-container"
            style={{ textAlign: "center", marginTop: "40px" }}
          >
            <i
              className="fas fa-folder-open"
              style={{
                fontSize: "70px",
                marginBottom: "15px",
                color: "#00685eff",
              }}
            ></i>
            <p
              id="adm-doc-error-1"
              style={{ textAlign: "center", color: "#888", fontSize: "18px" }}
            >
            {errorMessage}
          </p>
          </div>
        )}
    </div>
  );
};

export default AdmDocStatus;
